"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _errorMessage = _interopRequireDefault(require("./error-message.css"));

var ErrorMessage = function ErrorMessage(_ref) {
  var className = _ref.className,
      message = _ref.message,
      theme = _ref.theme;
  return /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _clsx["default"])(_errorMessage["default"].errorMessage, className)
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _clsx["default"])(theme.mmcIconFormError, _errorMessage["default"].errorMessageIcon)
  }), ' ', message);
};

var _default = ErrorMessage;
exports["default"] = _default;